<div class="container">
  <hyperkit-typography
    class="page-title"
    variant="h1"
    align="left"
    color="primary"
    >Manage Users</hyperkit-typography
  >
  <div class="users-wrapper">
    @if (isAdmin) {
      <hyperkit-button
        class="add-button"
        (click)="onAddUserModal()"
        size="small"
        variant="standard"
        text="Add User"
        icon="plus"
        color="tertiary"
      ></hyperkit-button>
    }

    <div class="users align-items-center">
      <kendo-grid
        [kendoGridBinding]="gridView"
        kendoGridSelectBy="id"
        [pageSize]="20"
        [pageable]="true"
        [sortable]="true"
        [groupable]="false"
        [selectable]="false"
        [reorderable]="true"
        [resizable]="true"
        [columnMenu]="{ filter: false }"
      >
        <ng-template kendoGridToolbarTemplate>
          <!-- <input
            [style.width.px]="225"
            placeholder="Search"
            kendoTextBox
            (input)="onFilter($event)"
            />
          <button id="search" type="submit">
            <i class="k-icon k-font-icon k-i-search"></i>
          </button> -->
          <hyperkit-search-input
            [placeholder]="'Search'"
            (textChange)="onFilter($event)"
            class="search-bar"
          >
          </hyperkit-search-input>
          <kendo-grid-spacer></kendo-grid-spacer>
        </ng-template>
        <kendo-grid-column [width]="125" field="name" title="Name">
          <ng-template kendoGridCellTemplate let-dataItem>
            @if (dataItem.firstName) {
              <span>{{ dataItem.firstName }} {{ dataItem.lastName }}</span>
            }
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="250" field="email" title="Email">
        </kendo-grid-column>
        <kendo-grid-column field="role" title="Role"> </kendo-grid-column>
        <kendo-grid-column [width]="100" field="status" title="Status">
          <ng-template kendoGridCellTemplate let-dataItem> Active </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="createdAt" title="Created">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.createdAt | date }}
          </ng-template>
        </kendo-grid-column>
        @if (isAdmin) {
          <kendo-grid-column
            [sortable]="false"
            field="id"
            title=""
            [width]="100"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="button-options">
                <hyperkit-button
                  (click)="editUser(dataItem)"
                  size="small"
                  variant="icon"
                  icon="edit"
                  color="tertiary"
                ></hyperkit-button>
                <hyperkit-button
                  (click)="deleteUser(dataItem)"
                  size="small"
                  variant="icon"
                  icon="trash"
                  color="secondary"
                ></hyperkit-button>
              </div>
            </ng-template>
          </kendo-grid-column>
        }
      </kendo-grid>
    </div>
  </div>
</div>
